module.exports = __webpack_public_path__ + "static/img/图片2.3777dbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/图片2.png
// module id = 3vla
// module chunks = 1